//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.Utils.ts							</Name>
//    <Description> Utilitky pro Adm							</Description>
//    <Author>      Tomáš Hažmuka								</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019			</Copyright>
//    <Created>     2019-01-09									</Created>
//  </FileHeader>

namespace Gordic.Adm.WebControls {
    export enum ITypePanel {
        Neurceno = 99
    }
}

namespace Gordic.Adm.Utils {

    /**
     * metoda pro smazání cache z políčka
     * - např. z Gordic.ControlsLogic.Client.GReaderGinspod
     * 
     * @author thazmuka
     * @since 484.1.0.5
     */
    export function clearCache(className: string) {
        if (className == null || className === "") { // null, undefined or empty
            console.log("Chybí předaná třída pro smazání cache");
        }
        else {
            var ReaderCache = Gordic.Data.readerCache;
            ReaderCache.clearCache(className);            // smazání cache z Readeru
        }
    }
    /** metoda pro smazání všech cache políček */
    export function clearAllCache() {
        var ReaderCache = Gordic.Data.readerCache;
        ReaderCache.clearCache("");            // smazání cache z Readeru
    }

    /**
        * metoda, která zvaliduje formulář a vrátí výsledek validace až je formulář připraven
        * 
        * @param {JQuery<HTMLElement>} form předaný element formuláře
        * @returns {JQueryPromise<boolean>} výsledek stavu
        */
    export function waitForValues(form: JQuery<HTMLElement>): JQueryPromise<boolean> {

        var dfd = $.Deferred();

        form.gform("waitForValues")
            .then(() => {
                return form.gform("isValid");
            })
            .then((isValid) => {
                dfd.resolve(isValid);
            })
            .fail(() => {
                dfd.reject(false);
            })

        return dfd.promise();
    }

    /** Typ výsledku operace */
    export enum GOperationResultKind {
        /** The success */
        Success = 200,
        /** The information */
        Info = 203,
        /** The warning */
        Warning = 206,
        /** The error */
        Error = 400
    }

    /** konstanty pro ISL v ADM - odpovídá C# třídě GAdmIslConst  */
    export enum GAdmIslConst {

        /** Konstanta pro jméno fragmentu, který svou přítomností signalizuje, že se nemají načítat data z DB, pouze se mají vrátit výchozí honodty pro požadovaný objekt */
        defaultValuesForNewRecord = "DefaultValuesForNewRecord",
        /** Konstanta pro jméno fragmentu, který svou přítomností signalizuje, že se jedná o položku, která je přítomná na detailu */
        detail = "detail",
        /** Konstanta pro jméno fragmentu, který svou přítomností signalizuje, že se jedná o položku, která je přítomná na seznamu */
        seznam = "seznam",
        /** Konstanta pro jméno fragmentu, který svou přítomností signalizuje, že se jedná o položku, která je všude - jak na seznamu, tak na detailu */
        everyWhere = ""
    }

    /**
     * na akci změní property enabled - povolí nebo zakáža 
     */
    export function setActionTooltip(Action: GAction | undefined, text: string | null | undefined): void {
        if (Action !== undefined) {					// pokud neni undefined, proved update
            Action.update({ tooltip: text });
        }
    }

	/**
	 * na akci změní property enabled - povolí nebo zakáža 
	 */
    export function setActionEnabled(Action: GAction | undefined, enabled: boolean | null | undefined): void {
        if (Action !== undefined) {					// pokud neni undefined, proved update
            if (!enabled)
                Action.update({ enabled: false });
            else
                Action.update({ enabled: true });
        }
    }

    export function setActionDisabled(Action: GAction | undefined, disabled: boolean | null | undefined): void {
        if (Action !== undefined) {					// pokud neni undefined, proved update
            if (!disabled)
                Action.update({ enabled: true });
            else
                Action.update({ enabled: false });
        }
    }

    /**
     * Test, zda podle objektu typu GAdmSubjectPermissions můžu editovat
     * @param permissions
     */
    export function getCanEdit(permissions: Gordic.AdmIsl.Interface.GAdmSubjectPermissions | null | undefined): boolean {
        var vysledek: boolean = false;
        if (permissions !== undefined && permissions !== null && permissions.CanWrite  != undefined && permissions.CanWrite !== null && permissions.CanWrite.value)
            vysledek = true;
        return (vysledek);
    }

    export function getCanAdd(permissions: Gordic.AdmIsl.Interface.GAdmSubjectPermissions | null | undefined): boolean {
        var vysledek: boolean = false;
        if (permissions !== undefined && permissions !== null && permissions.CanCreate != undefined && permissions.CanCreate !== null && permissions.CanCreate.value)
            vysledek = true;
        return vysledek;
    }

    export function getCanAddList(permissions: Gordic.General.ApplicationInterface.GDataAccessRightsEnum | null | undefined): boolean {
        var vysledek: boolean = false;
        if (permissions !== undefined && permissions !== null && permissions.Create != undefined && permissions.Create !== null && permissions.Create == true)
            vysledek = true;
        return vysledek;
    }
    
    /**
    * na akci změní property visibled - zobrazí nebo zneviditelní
    * @param Action
    * @param visible
    */
    export function setActionVisible(Action: GAction | undefined, visible: boolean | null | undefined): void {
        if (Action !== undefined) {					// pokud neni undefined, proved update
            if (!visible)
                Action.update({ visible: false });
            else
                Action.update({ visible: true });
        }
    }

//	/**
//	 * konverze base64 to UTF-8
//	 * @param str string
//	 */
//	export function b64DecodeUnicode(str: string) {
//		// Going backwards: from bytestream, to percent-encoding, to original string.
//		return decodeURIComponent(atob(str).split('').map(function (c) {
//			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
//		}).join(''));
//	}

	/**
     * test, jestli je grid prázdný
	 */
	export function isGridEmpty(grid): boolean {
		// vrací pole řádků seznamu
		var array = grid.ggrid("getSelection");
		if (array.length === 0) {
			return true;
		}
		else {
			return false;
		}
	}

    // Funkce pro obsluhu color políčka (valstnosti)
    /**
     * Převede číslo do hex
     * @param c číslo v desítkové soustavě
     */
    export function NumberToHex(c: number): string {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }

    /**
     * Převede hexadecimální číslo do desítkového
     * @param hex hexadecimální číslo
     */
    export function HexToNumber(hex: string): { r: number, g: number, b: number } | null {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) } : null
    }


    /**
     * item template pro colorbox
     * @param value hodnota barvy
     */
    export function ItemTemplateColorBox(value: any): JQuery<HTMLElement> {
        var el = $("<div>")
        $("<div style='color:{0}' class='fa fa-stop minifoto'>".format(value.hexa)).appendTo(el);
        $("<b>jres:33000058: {0}<b/>".format(value.hexa)).appendTo(el)
        $("<br />").appendTo(el)
        $("<i>jres:33000057({0}, {1}, {2})<i>".format(value.red, value.green, value.blue)).appendTo(el);
        return el;
    }
}